import { RowProps } from 'antd/es/row'
import { Row as AntRow } from 'antd'
import React, { FC } from 'react'

export const Row: FC<RowProps> = ({ children, gutter, ...props }) => (
  <AntRow {...props} gutter={gutter || 18}>
    {children}
  </AntRow>
)
